import React from "react";
import { Card } from "../../ui/Card";
import { LogIn, TrendingUp, TrendingDown, Compass, Calendar } from "lucide-react";

export function NationalParkKpiCards({
  todayVisitors = 0,
  rushHour = { visitors: 0, hourLabel: "--:--", dateLabel: "" },
  leadingLocation = { name: "—", count: 0 },
  lastWeekVisitors = 0,
  weeklyTrend = null,
}) {
  return (
    <div dir="rtl" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 w-full mb-4 text-right">
      <Card className="flex flex-col justify-between p-3.5 bg-gradient-to-br from-white to-indigo-50/40 border border-indigo-100 shadow-sm hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between">
          <span className="text-xs font-semibold text-gray-700">כניסות היום</span>
          <div className="p-1.5 rounded-lg bg-indigo-100/70 text-indigo-700">
            <LogIn className="h-4 w-4" />
          </div>
        </div>
        <div className="my-1.5 text-right">
          <div className="text-2xl lg:text-3xl font-extrabold text-indigo-900 tracking-tight">
            {Number(todayVisitors).toLocaleString("he-IL")}
          </div>
          <div className="text-[11px] text-gray-500 mt-0.5">רכבים שעברו בשערים · מ־04:00</div>
        </div>
      </Card>

      <Card className="flex flex-col justify-between p-3.5 bg-gradient-to-br from-white to-amber-50/40 border border-amber-100 shadow-sm hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between">
          <span className="text-xs font-semibold text-gray-700">שעת שיא (24 שעות)</span>
          <div className="p-1.5 rounded-lg bg-amber-100/70 text-amber-700">
            <TrendingUp className="h-4 w-4" />
          </div>
        </div>
        <div className="my-1.5 text-right">
          <div className="text-2xl lg:text-3xl font-extrabold text-amber-900 tracking-tight">
            {rushHour.visitors > 0 ? Number(rushHour.visitors).toLocaleString("he-IL") : "--"}
          </div>
          <div className="text-[11px] text-gray-500 mt-0.5">
            {rushHour.hourLabel}
            {rushHour.dateLabel ? ` (${rushHour.dateLabel})` : ""}
          </div>
        </div>
      </Card>

      <Card className="flex flex-col justify-between p-3.5 bg-gradient-to-br from-white to-purple-50/40 border border-purple-100 shadow-sm hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between">
          <span className="text-xs font-semibold text-gray-700">חניון מוביל</span>
          <div className="p-1.5 rounded-lg bg-purple-100/70 text-purple-700">
            <Compass className="h-4 w-4" />
          </div>
        </div>
        <div className="my-1.5 text-right">
          <div className="text-2xl lg:text-3xl font-extrabold text-purple-900 tracking-tight leading-tight truncate">
            {leadingLocation.name}
          </div>
          <div className="text-[11px] text-gray-500 mt-0.5">
            {leadingLocation.count > 0
              ? `${Number(leadingLocation.count).toLocaleString("he-IL")} כניסות היום`
              : "אין כניסות היום"}
          </div>
        </div>
      </Card>

      <Card className="flex flex-col justify-between p-3.5 bg-gradient-to-br from-white to-cyan-50/40 border border-cyan-100 shadow-sm hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between">
          <span className="text-xs font-semibold text-gray-700">רכבים בשבוע שעבר</span>
          <div className="p-1.5 rounded-lg bg-cyan-100/70 text-cyan-700">
            <Calendar className="h-4 w-4" />
          </div>
        </div>
        <div className="my-1.5 text-right">
          <div className="flex items-center justify-between gap-2">
            <div className="text-2xl lg:text-3xl font-extrabold text-cyan-900 tracking-tight">
              {lastWeekVisitors > 0 ? Math.round(lastWeekVisitors).toLocaleString("he-IL") : "--"}
            </div>
            {weeklyTrend !== null && weeklyTrend !== undefined && (
              <div
                className={`inline-flex items-center gap-0.5 px-2 py-0.5 rounded-full text-xs font-bold ${
                  weeklyTrend >= 0
                    ? "bg-emerald-100 text-emerald-700 border border-emerald-200"
                    : "bg-rose-100 text-rose-700 border border-rose-200"
                }`}
                title={`שינוי בהשוואה לשבוע שלפני: ${weeklyTrend >= 0 ? "+" : ""}${weeklyTrend}%`}
              >
                {weeklyTrend >= 0 ? (
                  <TrendingUp className="h-3.5 w-3.5" />
                ) : (
                  <TrendingDown className="h-3.5 w-3.5" />
                )}
                <span>{weeklyTrend >= 0 ? `+${weeklyTrend}%` : `${weeklyTrend}%`}</span>
              </div>
            )}
          </div>
          <div className="text-[11px] text-gray-500 mt-0.5">ראשון–שבת שהסתיים · כניסות בשערים</div>
        </div>
      </Card>
    </div>
  );
}

export default NationalParkKpiCards;
